export default __webpack_public_path__ + "static/media/Mystic's Gloves of the Purple Sun.b95b124e.jpg";